"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('jotai/utils');

var e = _utils.atomWithReset.call(void 0, !0),
    l = exports.b = _utils.atomWithReset.call(void 0, !1),
    n = exports.c = _utils.atomWithReset.call(void 0, 0),
    c = exports.d = _utils.atomWithReset.call(void 0, !0),
    r = exports.e = _utils.atomWithReset.call(void 0, {
  current: null
}),
    a = exports.f = _utils.atomWithReset.call(void 0, null);

exports.a = e;
exports.b = l;
exports.c = n;
exports.d = c;
exports.e = r;
exports.f = a;